"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullUrl = exports.FetchRequest = exports.XhrRequest = void 0;
var Emitter_1 = __importDefault(require("licia/Emitter"));
var isStr_1 = __importDefault(require("licia/isStr"));
var last_1 = __importDefault(require("licia/last"));
var Url_1 = __importDefault(require("licia/Url"));
var isEmpty_1 = __importDefault(require("licia/isEmpty"));
var trim_1 = __importDefault(require("licia/trim"));
var now_1 = __importDefault(require("licia/now"));
var each_1 = __importDefault(require("licia/each"));
var startWith_1 = __importDefault(require("licia/startWith"));
var toNum_1 = __importDefault(require("licia/toNum"));
var util_1 = require("./util");
var XhrRequest = (function (_super) {
    __extends(XhrRequest, _super);
    function XhrRequest(xhr, method, url) {
        var _this = _super.call(this) || this;
        _this.xhr = xhr;
        _this.reqHeaders = {};
        _this.method = method;
        _this.url = fullUrl(url);
        _this.id = util_1.createId();
        return _this;
    }
    XhrRequest.prototype.toJSON = function () {
        return {
            method: this.method,
            url: this.url,
            id: this.id,
        };
    };
    XhrRequest.prototype.handleSend = function (data) {
        if (!isStr_1.default(data))
            data = '';
        data = {
            name: getFileName(this.url),
            url: this.url,
            data: data,
            time: now_1.default(),
            reqHeaders: this.reqHeaders,
            method: this.method,
        };
        if (!isEmpty_1.default(this.reqHeaders)) {
            data.reqHeaders = this.reqHeaders;
        }
        this.emit('send', this.id, data);
    };
    XhrRequest.prototype.handleReqHeadersSet = function (key, val) {
        if (key && val) {
            this.reqHeaders[key] = val;
        }
    };
    XhrRequest.prototype.handleHeadersReceived = function () {
        var xhr = this.xhr;
        var type = getType(xhr.getResponseHeader('Content-Type') || '');
        this.emit('headersReceived', this.id, {
            type: type.type,
            subType: type.subType,
            size: getSize(xhr, true, this.url),
            time: now_1.default(),
            resHeaders: getHeaders(xhr),
        });
    };
    XhrRequest.prototype.handleDone = function () {
        var _this = this;
        var xhr = this.xhr;
        var resType = xhr.responseType;
        var resTxt = '';
        var update = function () {
            _this.emit('done', _this.id, {
                status: xhr.status,
                size: getSize(xhr, false, _this.url),
                time: now_1.default(),
                resTxt: resTxt,
            });
        };
        var type = getType(xhr.getResponseHeader('Content-Type') || '');
        if (resType === 'blob' &&
            (type.type === 'text' ||
                type.subType === 'javascript' ||
                type.subType === 'json')) {
            readBlobAsText(xhr.response, function (err, result) {
                if (result)
                    resTxt = result;
                update();
            });
        }
        else {
            if (resType === '' || resType === 'text')
                resTxt = xhr.responseText;
            if (resType === 'json')
                resTxt = JSON.stringify(xhr.response);
            update();
        }
    };
    return XhrRequest;
}(Emitter_1.default));
exports.XhrRequest = XhrRequest;
var FetchRequest = (function (_super) {
    __extends(FetchRequest, _super);
    function FetchRequest(url, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        if (url instanceof window.Request)
            url = url.url;
        _this.url = fullUrl(url);
        _this.id = util_1.createId();
        _this.options = options;
        _this.reqHeaders = options.headers || {};
        _this.method = options.method || 'GET';
        return _this;
    }
    FetchRequest.prototype.send = function (fetchResult) {
        var _this = this;
        var options = this.options;
        var data = isStr_1.default(options.body) ? options.body : '';
        this.emit('send', this.id, {
            name: getFileName(this.url),
            url: this.url,
            data: data,
            reqHeaders: this.reqHeaders,
            time: now_1.default(),
            method: this.method,
        });
        fetchResult.then(function (res) {
            res = res.clone();
            var type = getType(res.headers.get('Content-Type'));
            res.text().then(function (resTxt) {
                var data = {
                    type: type.type,
                    subType: type.subType,
                    time: now_1.default(),
                    size: getFetchSize(res, resTxt),
                    resTxt: resTxt,
                    resHeaders: getFetchHeaders(res),
                    status: res.status,
                };
                if (!isEmpty_1.default(_this.reqHeaders)) {
                    data.reqHeaders = _this.reqHeaders;
                }
                _this.emit('done', _this.id, data);
            });
            return res;
        });
    };
    return FetchRequest;
}(Emitter_1.default));
exports.FetchRequest = FetchRequest;
function getFetchSize(res, resTxt) {
    var size = 0;
    var contentLen = res.headers.get('Content-length');
    if (contentLen) {
        size = toNum_1.default(contentLen);
    }
    else {
        size = lenToUtf8Bytes(resTxt);
    }
    return size;
}
function getFetchHeaders(res) {
    var ret = {};
    res.headers.forEach(function (val, key) { return (ret[key] = val); });
    return ret;
}
function getHeaders(xhr) {
    var raw = xhr.getAllResponseHeaders();
    var lines = raw.split('\n');
    var ret = {};
    each_1.default(lines, function (line) {
        line = trim_1.default(line);
        if (line === '')
            return;
        var _a = line.split(':', 2), key = _a[0], val = _a[1];
        ret[key] = trim_1.default(val);
    });
    return ret;
}
function getSize(xhr, headersOnly, url) {
    var size = 0;
    function getStrSize() {
        if (!headersOnly) {
            var resType = xhr.responseType;
            var resTxt = '';
            if (resType === '' || resType === 'text')
                resTxt = xhr.responseText;
            if (resTxt)
                size = lenToUtf8Bytes(resTxt);
        }
    }
    if (isCrossOrig(url)) {
        getStrSize();
    }
    else {
        try {
            size = toNum_1.default(xhr.getResponseHeader('Content-Length'));
        }
        catch (e) {
            getStrSize();
        }
    }
    if (size === 0)
        getStrSize();
    return size;
}
var link = document.createElement('a');
function fullUrl(href) {
    link.href = href;
    return (link.protocol + '//' + link.host + link.pathname + link.search + link.hash);
}
exports.fullUrl = fullUrl;
function getFileName(url) {
    var ret = last_1.default(url.split('/'));
    if (ret.indexOf('?') > -1)
        ret = trim_1.default(ret.split('?')[0]);
    if (ret === '') {
        var urlObj = new Url_1.default(url);
        ret = urlObj.hostname;
    }
    return ret;
}
function getType(contentType) {
    if (!contentType)
        return {
            type: 'unknown',
            subType: 'unknown',
        };
    var type = contentType.split(';')[0].split('/');
    return {
        type: type[0],
        subType: last_1.default(type),
    };
}
function readBlobAsText(blob, callback) {
    var reader = new FileReader();
    reader.onload = function () {
        callback(null, reader.result);
    };
    reader.onerror = function (err) {
        callback(err);
    };
    reader.readAsText(blob);
}
var origin = window.location.origin;
function isCrossOrig(url) {
    return !startWith_1.default(url, origin);
}
function lenToUtf8Bytes(str) {
    var m = encodeURIComponent(str).match(/%[89ABab]/g);
    return str.length + (m ? m.length : 0);
}
